import { api, LightningElement, wire } from "lwc";

import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";
import { createTrack, TrackEvent } from "common/track";

import * as locales from "./locales";

import type { FooterContent } from "./types";
export type { FooterContent };

export default class extends LightningElement {
  @api content: FooterContent = null!;

  @wire(LabelsAdapter, { locales })
  private labels: LabelsAdapterValue = null!;

  private track = createTrack<"tds-footer">(this);

  private get selectedLocale() {
    if (!this.content.locales || !this.content.locales.length) return undefined;
    let locale = this.content.locales.find((locale) => locale.selected);
    return locale ? locale.value : this.content.locales[0].value;
  }

  private handleGlobalTrack(e: TrackEvent<"tds-footer-global">) {
    let eventName = e.detail.eventName;
    this.track(eventName, e.detail.payload);
  }

  private handleLinkClick(e: CustomEvent) {
    this.dispatchEvent(new CustomEvent(e.type, { detail: e.detail }));
  }

  private handleLinksTrack(e: TrackEvent<"tds-footer-links">) {
    let eventName = e.detail.eventName;
    this.track(eventName, e.detail.payload);
  }

  private handleLocaleChange(e: CustomEvent<string>) {
    this.dispatchEvent(
      new CustomEvent("locale_change", {
        detail: { value: e.detail },
      })
    );
    this.track("language_selector_changed", { label: e.detail });
  }
}
